import Qs from 'query-string';
import api from 'api/client';
import { pathFromRoute } from 'utils';
import ROUTES from 'routes';

export function fetchFeedback (pswd, archived) {
  const path = pathFromRoute(ROUTES.API.FEEDBACK);
  return api.get(`${ path }?${ Qs.stringify({ pswd, archived }) }`);
}

export function addFeedback ({ data }) {
  const path = pathFromRoute(ROUTES.API.FEEDBACK);
  return api.post(path, data);
}

export function archiveFeedback (pswd, { id }) {
  const path = pathFromRoute(ROUTES.API.FEEDBACK_ARCHIVE, { id });
  return api.post(`${ path }?${ Qs.stringify({ pswd }) }`);
}

export function deleteFeedback (pswd, { id }) {
  const path = pathFromRoute(ROUTES.API.FEEDBACK, { id });
  return api.delete(`${ path }?${ Qs.stringify({ pswd }) }`);
}
